// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"15a8413c","142":"75a88b73","149":"b5447772","488":"05d37ee7","493":"32654b36","636":"676eee0d","649":"e7729003","677":"338df0cc","780":"27c973e8","836":"7ac653bb","953":"3ff3d23d","985":"3bb5e536","988":"6a8391ff","993":"a15b8243"}[chunkId] + ".chunk.js";
};